module.exports = __webpack_public_path__ + "img/autoschlüssel.723caf6f.png";